module.exports = __webpack_public_path__ + "img/transaction.180e2cb6.png";